import { Modal, Button } from 'react-bootstrap';
import InnerTile from '../kanban/inner-tile';
import KanbanAPI from './../../api/kanban-board/kanban-api-factory';
import { useMsal } from '@azure/msal-react';
import React, { useState, useEffect, useMemo } from "react";
import LoadingAnimation from '../loading/loading';

export const EventModal = ({ show, handleCancel, tileId }) => {

    const { instance, inProgress, accounts } = useMsal();
    const kanbanAPI = useMemo(() => new KanbanAPI(instance, inProgress, accounts, false), [instance, inProgress, accounts]);

    const [fetchInProgress, setFetchInProgress] = useState(false);
    const [shouldFetch, setShouldFetch] = useState(true);
    const [tile, setTile] = useState(null);

    useEffect(() => {
        const getTile = async () => {

            const data = await kanbanAPI.getSingleTileById(tileId);
            setTile(data);
            setFetchInProgress(false);
            setShouldFetch(false);
        };
        if (!fetchInProgress && !!shouldFetch) {
            setFetchInProgress(true);
            getTile();
        }

    }, [fetchInProgress, shouldFetch]);

    return (
        <Modal
            show={show}
            onHide={handleCancel}
            backdrop="static"
            keyboard={true}
        >
            <Modal.Header closeButton>
                <Modal.Title>Event Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {tile &&
                    <InnerTile tile={tile} editable={false} />
                }
                {shouldFetch && fetchInProgress &&
                    <>Loading...</>
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCancel}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};